import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #000;
  height: 120px;
  @media (max-width: 1080px) {
    height: 224px;
    padding: 16px 0;
  }
  @media (max-width: 540px) {
    height: 300px;
    padding: 32px 0;
  }
  .wrapper {
    justify-content: space-between;
    flex-wrap: wrap;
    .text {
      font: italic bold 24px 'Times new roman';
      color: #fff;
      max-width: 280px;
      @media (max-width: 1080px) {
        max-width: inherit;
        width: 100%;
      }
    }
    input {
      border: 0;
      border-bottom: 2px solid #464646;
      color: #fff;
      height: 48px;
      background: 0;
      max-width: 280px;
      font-size: 16px;
      width: 100%;
      transition: all 0.3s;
      &:focus {
        border-color: #C7C7C7;
      }
      @media (max-width: 1080px) {
        max-width: 48%;
      }
      @media (max-width: 540px) {
        max-width: 100%;
      }
    }
    :-ms-input-placeholder,
    &::-ms-input-placeholder,
    &::placeholder {
      color: #fff;
      opacity: 1;
    }
    button {
      cursor: pointer;
      max-width: 180px;
      width: 100%;
      background: #484848;
      display: flex;
      border-radius: 3px;
      border: 0;
      color: #fff;
      height: 48px;
      align-items: center;
      font-size: 14px;
      padding: 0;
      transition: all 0.3s;
      &:hover {
        background: #797979;
        span {
          border-color: #5E5E5E;
        }
      }
      @media (max-width: 1080px) {
        margin: 0 auto;
      }
      .btn-text {
        height: 100%;
        flex-grow: 1;
        border-right: 1px solid #3B3B3B;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon {
        display: flex;
        align-items: center;
        min-width: 46px;
        justify-content: center;
        i {
          width: 15px;
          background: url(/images/arrow-right.png) center no-repeat;
          height: 15px;
          background-size: contain;
        }
      }
    }
  }
  input::placeholder {
    color: #fff;
    opacity: 1;
  }
`

class Newsletter extends Component {
  render () {
    const { language } = this.context;
    let titleText = ''
    let buttonText = ''
    let nome = ''
    let email = ''
    switch (language) {
      case 'pt-br':
        titleText = 'Fique por dentro de todas as novidades da Guararapes';
        buttonText = 'Cadastrar';
        nome = 'Preencha seu nome';
        email = 'Preencha seu email';
        break;
      case 'en-us':
        titleText = 'Stay on top of all the news from Guararapes';
        buttonText = 'Register';
        nome = 'Fill in your name';
        email = 'Fill in your email';
        break;
      case 'es-es':
        titleText = 'Mantente al tanto de todas las novedades de Guararapes';
        buttonText = 'Registrar';
        nome = 'Escribe tu nombre';
        email = 'Complete su correo electrónico';
        break;
      default:
    }
    return (
      <Container id="newsletter">
        <div className="wrapper flex">
          <span className="text">
            { titleText }
          </span>
          <input type="text" placeholder={ nome } />
          <input type="email" placeholder={ email } />
          <button>
            <span className="btn-text">{ buttonText }</span>
            <span className="icon">
              <i></i>
            </span>
          </button>
        </div>
      </Container>
    )
  }
}

Newsletter.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Newsletter.contextType = LanguageContext;

export default Newsletter;
